import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Search from '@ifeng/ui_pc_search';
import errorBoundary from '@ifeng/errorBoundary';
import Logo from './logo';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { search, logo, domain, breadCrumbdata } = content;
        const logoData = { logo, domain, breadCrumbdata };

        return (
            <div className={styles.header_box}>
                <div className={styles.header}>
                    <Logo content={logoData} />
                    <NoSSR>
                        <Search content={search} />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
